function Research() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-6">
      <div className="bg-white shadow-lg rounded-xl p-8">
        <h2 className="text-2xl font-bold text-indigo-700 mb-4">Estimating Computational Load and Electrical Power Requirements of AI Leveraging Edge Intelligence</h2>
        <p className="mb-2"><strong>PI:</strong> Dr. Andrea Ramirez-Salgado</p>
        <p className="mb-2"><strong>Institution:</strong> University of Florida, Department of Engineering Education</p>
        <p className="mb-6"><strong>Affiliation:</strong> 2024 – Present</p>

        <h3 className="text-xl font-semibold mb-3">Research Focus</h3>
        <p className="text-gray-700 leading-relaxed mb-6">
          This project will estimate the computational and electrical power requirements of EI applications. My goal is to work with with the University of Florida’s experts on EI and explore AI power requirements for the community-relevant application of air quality monitoring.
        </p>
        <img
          src="/research-pic.jpg"
          alt="Research project"
          className="rounded-lg shadow-md mx-auto"
        />
      </div>
    </div>
  );
}
export default Research;